/**
* @file H5和RN通信
* @author PJ
*/

/* eslint-disable no-undef, no-alert, no-underscore-dangle */
import Qs from 'qs';
import Vue from 'vue';
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


Vue.use(WechatPlugin);

const SUPPORT_MAP = {
checkAppLoginStatus: {
min: 1130,
},
goAppLogin: {
min: 1130,
},
};

const wx = Vue.wechat;

const Bridge = {
invoke: (funName, cb, parameter = {}) => {
const callback = cb || (() => {});

if (window.__wxjs_environment === 'miniprogram') { // eslint-disable-line
if (wx.miniProgram) {

}
return;
}


if (window.WebViewJavascriptBridge
&& window.WebViewJavascriptBridge.invoke) {

window.WebViewJavascriptBridge.invoke(funName, (res) => {
const {
data = {},
} = res;
callback(data);
}, parameter);
}
},
};

const aliApiSafeRun = (task) => {
if (navigator.userAgent.indexOf('AlipayClient') > -1) task();
else window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
};


export const bridgeInvoke = (funName, cb = (params = '') => params, params = {}) => {
if (window.WebViewJavascriptBridge &&
window.WebViewJavascriptBridge.invoke) {
window.WebViewJavascriptBridge.invoke(funName, (res) => {
const {
data = {},
} = res;
cb(data);
}, params);
}
};

/**
*
* @param {Number} pkgVersion
* @param {String} bridgeName
* @return {Boolean}
*/
export const bridgeVerCheck = (pkgVersion, bridgeName) => {
let support = false;
if (SUPPORT_MAP[bridgeName]) {
const min = SUPPORT_MAP[bridgeName].min;
const max = SUPPORT_MAP[bridgeName].max;

if (min !== undefined) {
support = +pkgVersion >= +min;
}

if (support && max !== undefined) {
support = +pkgVersion <= +max;
}
if (!support) {

}
} else {

}
return support;
};



export const wxRedirectTo = (params) => {
if (window.__wxjs_environment !== 'miniprogram') {
window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
} else {
wx.miniProgram.redirectTo({
url: params.url,
});
}
};


export const aliRedirectTo = (params) => {
aliApiSafeRun(() => {
window.my.redirectTo({
url: params.url,
});
});
};


export const wxNavigateTo = (params) => {
if (window.__wxjs_environment !== 'miniprogram') {
window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
} else {
wx.miniProgram.navigateTo({
url: params.url,
});
}
};


export const aliNavigateTo = (params) => {
aliApiSafeRun(() => {
window.my.navigateTo({
url: params.url,
});
});
};


export const wxNavigateBack = (step = 1) => {
if (window.__wxjs_environment !== 'miniprogram') {
window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
} else {
wx.miniProgram.navigateBack(step);
}
};


export const aliNavigateBack = (step = 1) => {
aliApiSafeRun(() => {
window.my.navigateBack(step);
});
};


export const wxPostMessage = (data) => {
if (window.__wxjs_environment !== 'miniprogram') {
window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
} else {
wx.miniProgram.postMessage({
data,
});
}
};


export const aliPostMessage = (data) => {
aliApiSafeRun(() => {
const my = window.my;
my.postMessage({
data,
});
});
};


export const wxGetLocation = (cb, failFunc = () => {}) => {
if (window.__wxjs_environment !== 'miniprogram') {
window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
} else {
alert(wx.miniProgram.postMessage);
wx.miniProgram.getLocation({
type: 'gcj02',
success() {
if (typeof cb === 'function') cb(res);
},
fail: failFunc,
});
}
};

export const wxShare = (
wxConfig,
canShare,
params,
data = {
title: '',
desc: '',
imgUrl: '',
link: window.location.href,
},
onSuccess = (param = '') => param,
onCancel = (param = '') => param,
callBack = (param = '') => param,
) => {
wx.config({
debug: false,
appId: wxConfig.appid,
timestamp: wxConfig.timestamp,
nonceStr: wxConfig.noncestr,
signature: wxConfig.signature,
jsApiList: ['hideMenuItems', 'showMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
});

wx.error(() => {
callBack();
});

wx.ready(() => {
if (!canShare) {
wx.hideMenuItems({
menuList: [
'menuItem:share:qq',
'menuItem:share:QZone',
'menuItem:share:appMessage',
'menuItem:share:timeline',
], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
});
} else {
wx.showMenuItems({
menuList: [
'menuItem:share:appMessage',
'menuItem:share:timeline',
], // 要显示的菜单项，所有menu项见附录3
});
wx.hideMenuItems({
menuList: [
'menuItem:share:qq',
'menuItem:share:QZone',
], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
});

wx.onMenuShareTimeline({ ...data,
link: `${data.link}?${Qs.stringify({ ...params, source: 'moments' })}`,
success() {
onSuccess('moments');
},
cancel() {
onCancel('moments');
},
});


wx.onMenuShareAppMessage({ ...data,
link: `${data.link}?${Qs.stringify({ ...params, source: 'friends' })}`,
success() {
onSuccess('friends');
},
cancel() {
onCancel('friends');
},
});
}
callBack();
});
};
/* eslint-enable no-undef, no-alert, no-underscore-dangle */


export default Bridge;



// WEBPACK FOOTER //
// ./src/utils/Bridge/index.js